import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import SelectFilter from '../search_sidebar/select_filter';

export default class UserSelect extends React.Component {
  static propTypes = {
    blankIcon: PropTypes.object,
    blankLabel: PropTypes.string,
    blankOption: PropTypes.bool,
    displayImage: PropTypes.bool,
    fixedLabel: PropTypes.string,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      imageUrl: PropTypes.string,
      name: PropTypes.string.isRequired
    })).isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func
  };

  static defaultProps = {
    blankIcon: faUsers,
    blankLabel: 'All',
    blankOption: false,
    displayImage: true
  };

  formatBlankOption = () => {
    const { blankIcon, blankLabel, blankOption, displayImage } = this.props;
    if (!blankOption) return;

    return (
      <div className="user-option blank-option" key="blank-option">
        {displayImage && blankIcon &&
          <FontAwesomeIcon className="me-2" icon={blankIcon} />
        }
        {blankLabel}
      </div>
    );
  };

  formatLabel = (user, ctx) => {
    const { id, imageUrl, name } = user;
    const { displayImage } = this.props;

    if (!id) {
      if (ctx.context === 'value') return null;
      return this.formatBlankOption();
    }

    if (ctx.context !== 'value') {
      return (
        <div className="user-option" key={id}>
          {displayImage && imageUrl &&
            <img className="avatar me-2" src={imageUrl} />
          }
          <span>{name}</span>
        </div>
      );
    } else {
      const { fixedLabel } = this.props;

      return (
        <div className="user-option" key={id}>
          {fixedLabel && <span>{fixedLabel}: </span>}
          {displayImage && imageUrl &&
          <img className="avatar me-2" src={imageUrl} />
          }
          <span>{name}</span>
        </div>
      );
    }
  };

  handleSelect = (user) => {
    const { onChange } = this.props;

    if (onChange != null) {
      onChange(user && user.id);
    }
  }

  selectedUser = () => this.props.users.find(user => user.id === this.props.value);

  render() {
    const { blankOption, onChange, users, value, ...selectProps } = this.props;
    const userOptions = blankOption ? [{ id: undefined, name: '' }, ...users] : users;

    return (
      <SelectFilter
        blurInputOnSelect={true}
        formatOptionLabel={this.formatLabel}
        getOptionLabel={user => user.name}
        getOptionValue={user => user.id}
        isClearable={false}
        name='user-select-inner'
        options={userOptions}
        value={this.selectedUser() || ""}
        onChange={this.handleSelect}
        {...selectProps}
      />
    );
  }
}
